import { IPremiumDetails } from 'types/order/title/IPolicyPremiumDetailsResponse';
import { prettyCoverageTypes, eCoverageType } from 'ui-toolkit/enums/eCoverageType';

const adjustmentTest = /just/;
const taxTest = /ax/;
const lenderTest = /[lL]ender/;

const appendSalesTax = (description: string) => (taxTest.test(description) ? ' Sales Tax' : '');

export const convertPremiumDetailsDescription = (
  details: IPremiumDetails[],
  coverageTypes: {
    lenderFormType?: eCoverageType;
    ownerFormType?: eCoverageType;
  }
): IPremiumDetails[] => {
  const mapper = generateMapper(coverageTypes);
  return details.map(mapper);
};

function generateMapper(coverageTypes: { lenderFormType?: eCoverageType; ownerFormType?: eCoverageType }) {
  return (premiumDetails: IPremiumDetails) => {
    const { description, ...rest } = premiumDetails;
    if (adjustmentTest.test(description)) {
      return premiumDetails;
    }
    if (lenderTest.test(description)) {
      if (coverageTypes.lenderFormType) {
        return {
          description: `${prettyCoverageTypes[coverageTypes.lenderFormType]}${appendSalesTax(description)}`,
          ...rest,
        };
      }
    } else if (coverageTypes.ownerFormType) {
      return {
        description: `${prettyCoverageTypes[coverageTypes.ownerFormType]}${appendSalesTax(description)}`,
        ...rest,
      };
    }
    return premiumDetails;
  };
}
